module.exports = __webpack_public_path__ + "static/img/b7efe2eab8460b20b80674b1cfaa0bed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index_pro1.jpg
// module id = ZtFi
// module chunks = 1